import { useState, useEffect, useRef } from "react";
import LeadershipAPI from "../../../api/LeadershipAPI";

const useFetchAgentLeadership = ({ userId, page = 1, limit = 10 }) => {
	const [loading, setLoading] = useState(false);
	const [rows, setRows] = useState([]);
	const [historyRows, setHistoryRows] = useState([]);
	const [totalEarnings, setTotalEarnings] = useState(0);
	const [total, setTotal] = useState(0);

	const abortControllerRef = useRef(null);

	const fetchAgentLeadership = async () => {
		if (abortControllerRef.current) {
			abortControllerRef.current.abort();
		}
		abortControllerRef.current = new AbortController();
		const signal = abortControllerRef.current.signal;

		setLoading(true);

		try {
			const result = await LeadershipAPI.getAgentLeadership({
				user_id: userId,
				page,
				limit,
				signal,
			});

			setRows(result.data);
			setTotal(result.total);
			setHistoryRows(result?.agent_own_leadership);
			setTotalEarnings(result?.total_earnings);
		} catch (error) {
			if (error.name === "AbortError") return;
			console.error("Failed to fetch agent leadership:", error);
			setRows([]);
			setTotal(0);
		} finally {
			if (!signal.aborted) {
				setLoading(false);
			}
		}
	};

	useEffect(() => {
		fetchAgentLeadership();
	}, [userId, page, limit]);

	return { rows, historyRows, totalEarnings, total, loading, refetch: fetchAgentLeadership };
};

export default useFetchAgentLeadership;
